import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from '../../../components/Button';

class TemplateRow extends React.Component {
	static propTypes = {
		template: PropTypes.object,
		onCancel: PropTypes.func,
		onSave: PropTypes.func.isRequired,
		onDelete: PropTypes.func,
		onClickEditSchedule: PropTypes.func.isRequired
	}

	constructor(props) {
		super(props);

		this.state = {
			editting: !props.template.id,
			showButtons: false,
			active: true
		};
	}

	handleMouseEnter = () => {
		this.setState({ showButtons: true });
	}

	handleMouseLeave = () => {
		this.setState({ showButtons: false });
	}

	handleCancel = () => {
		this.setState({ editting: false });
		if (this.props.onCancel) {
			this.props.onCancel();
		}
	}

	handleSave = () => {
		const { template } = this.props;
		const { name, description, active } = this.state;
		this.props.onSave({
			...template,
			template_name: name,
			description,
			active_ind: active,
		});
		this.setState({ editting: false });
	}

	handleDelete = () => {
		this.props.onDelete(this.props.template);
	}

	handleEditToggle = () => {
		const { template } = this.props;
		this.setState({
			editting: true,
			name: template.template_name,
			description: template.description,
			active: template.active_ind
		});
	}

	handleNameChange = ({ target }) => {
		this.setState({ name: target.value });
	}

	handleDescriptionChange = ({ target }) => {
		this.setState({ description: target.value });
	}

	handleActiveChange = () => {
		this.setState(currState => ({ active: !currState.active }));
	}

	handleEditSchedule = () => {
		this.props.onClickEditSchedule(this.props.template);
	}

	render() {
		const { template } = this.props;
		const { editting, showButtons, name, description, active } = this.state;

		return (
			<tr onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
				<td>
					{editting ? (
						<input type="text" className="form-control" value={name} onChange={this.handleNameChange} ref={input => this.nameInput = input} />
					) : (
						template.template_name
					)}
				</td>
				<td>
					{editting ? (
						<input type="text" className="form-control" value={description} onChange={this.handleDescriptionChange} ref={input => this.descriptionInput = input} />
					) : (
						template.description
					)}
				</td>
				<td>
					{editting ? (
						<div className="checkbox c-checkbox">
							<label>
								<input type="checkbox" checked={active} onChange={this.handleActiveChange} />
								<span className="fa fa-check"></span>
							</label>
						</div>
					) : (
						<em className={cn('fa', {
							'fa-times': !template.active_ind,
							'fa-check': template.active_ind,
							'text-danger': !template.active_ind,
							'text-success': template.active_ind
						})} />
					)}
				</td>
				<td className="text-right">
					<Button title="Save" shown={editting} onClick={this.handleSave} />
					<Button title="Cancel" shown={editting} onClick={this.handleCancel} />
					<Button shown={!editting} visible={showButtons} onClick={this.handleEditToggle} />
					<Button shown={!editting} visible={showButtons} danger isDelete onClick={this.handleDelete} />
					<Button shown={!editting} visible={showButtons} title="Edit Schedule" onClick={this.handleEditSchedule} />
				</td>
			</tr>
		);
	}

}

export default TemplateRow;
